import './aiSparkButton.css';

/** The centered sparkle + coral stop (viewBox 100). Ported from the approved reference. */
export default function SparkMark({ size }) {
  return (
    <svg className="cvx-ais__mk" width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
      <g className="cvx-ais__sg" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path className="cvx-ais__fillstar" d="M50 14 Q55 45 86 50 Q55 55 50 86 Q45 55 14 50 Q45 45 50 14Z" stroke="none" />
        <path className="cvx-ais__seg1" d="M50 86 Q45 55 14 50 Q45 45 50 14" strokeWidth="8" pathLength="100" />
        <path className="cvx-ais__seg2" d="M50 14 Q55 45 86 50 Q55 55 50 86" strokeWidth="8" pathLength="100" />
        <path className="cvx-ais__shine" d="M50 14 Q55 45 86 50 Q55 55 50 86 Q45 55 14 50 Q45 45 50 14Z" strokeWidth="8" pathLength="100" />
      </g>
      <circle className="cvx-ais__ping" cx="80" cy="20" r="7.5" />
      <circle className="cvx-ais__stop" cx="80" cy="20" r="7.5" />
    </svg>
  );
}
